import { Box, Typography, useMediaQuery } from "@mui/material";

function Home() {
  const appBarHeight =
    document.querySelector(".MuiAppBar-root")?.clientHeight || 100;
  const isMdScreen = useMediaQuery("(max-width:1200px)");
  const isLgScreen = useMediaQuery("(min-width:1200px) and (max-width:1600px)");
  const is600to900 = useMediaQuery("(min-width:600px) and (max-width:900px)");
  const isSmScreen = useMediaQuery("(max-width:600px)");
  return (
    <section
      id="home"
      style={{
        height: isSmScreen || is600to900 ? "auto" : "100vh",
        alignItems:"center",
        paddingTop: `${appBarHeight}px`,
        background:
          "linear-gradient(124deg, rgba(0, 0, 0, 1) 50%, rgba(128, 0, 128, 0.6) 100%)",
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems={"center"}
        width="100%"
        height= {isSmScreen ? "auto" : "100vh"}
        flexDirection={isSmScreen || is600to900 ? "column":"row"}
        sx={{ gap: { xs: 0, md: 6,lg:8,xl:30 } }}

        //p={4}
      >
        <img
          src="/images/avatar.png"
          style={{
            height:  is600to900 ? "350px" : isMdScreen ? "300px"  : "300px",
            width: is600to900 ? "350px" : isMdScreen ? "300px"  : "300px",
          }}
          alt="logo"
          // className="header-logo"
        />
        <Box
          display="flex"
          flexDirection="column"

  sx={{
    border: "rgb(175, 169, 169)",
    boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.3)",
    borderRadius: "12px",
    padding: isMdScreen ? "20px"  : isLgScreen ? "20px" : "50px",
    gap: is600to900 ? 4 : 2,
    marginTop:isSmScreen || is600to900 ? "16px" : 0,
    marginBottom: isSmScreen || is600to900 ? "20px" : "0px",
    width: isSmScreen || is600to900 ? "90%" : "auto",
    boxSizing: 'border-box', // Include padding and borders in width calculation
  }}
        >
          <Typography
            variant={isMdScreen ? "h5" : "h4"}
            sx={{ color: "white" }}
          >
            Greetings,
          </Typography>
          <Typography
            variant={isMdScreen ? "h4" : "h2"}
            sx={{ color: "white", fontWeight: "bold" }}
          >
            This is Shizza
          </Typography>
          <Typography
            variant={isMdScreen ? "h5" : "h3"}
            sx={{ color: "white", fontWeight: "bold" }}
          >
            Experienced Full Stack Developer
          </Typography>
          <Typography
            variant={isMdScreen ? "h6" : "h5"}
            sx={{ color: "white" }}
          >
            ~ Structured, high quality & optimal software solutions
          </Typography>
        </Box>
      </Box>
    </section>
  );
}

export default Home;
